import { LogViewerGrid } from "@/components/admin/LogViewerGrid";
import { usePageBreadcrumbs } from "@/components/layout/breadcrumb-context";
import { useAuthProfile } from "@/hooks/use-auth-profile";
import { FileText, Loader2 } from "lucide-react";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function AdminLogsPage() {
  const breadcrumbs = useMemo(
    () => [
      { label: "Recipe Boxes", href: "/home" },
      { label: "Admin", href: "/admin" },
      { label: "Error Logs" },
    ],
    [],
  );
  usePageBreadcrumbs(breadcrumbs);

  const { user, profile, loading } = useAuthProfile();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    } else if (!loading && user && profile && !profile.isAdmin) {
      // Redirect non-admin users
      navigate("/home");
    }
  }, [loading, user, profile, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user || !profile || !profile.isAdmin) {
    return null; // Will redirect
  }

  return (
    <div className="container max-w-7xl mx-auto py-6 px-4 space-y-6">
      {/* Header */}
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <FileText className="h-8 w-8 text-primary" />
          <h1 className="font-headline text-3xl font-semibold tracking-tight">Error Logs</h1>
        </div>
        <p className="text-muted-foreground">
          View, search, and manage application error logs from all platforms.
        </p>
      </div>

      {/* Log Viewer Grid */}
      <LogViewerGrid />
    </div>
  );
}
